export default __webpack_public_path__ + "static/media/walks.b4a9d532.svg";